import { render } from "./PublicTrips.vue?vue&type=template&id=1c24cc12&scoped=true"
import script from "./PublicTrips.vue?vue&type=script&lang=js"
export * from "./PublicTrips.vue?vue&type=script&lang=js"

import "./PublicTrips.vue?vue&type=style&index=0&id=1c24cc12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c24cc12"]])

export default __exports__